import '.f3{font-size:1.125rem;}.ssr-plugin'
import '.dz{line-height:1.75rem;}.ssr-plugin'
import '.fc{text-decoration:none;}.ssr-plugin'
import '.h8{color:var(--brand-primary);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="f3 dz"
    >
      {translations.privacySubtitle}{' '}
      <a className="fc h8"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="fc h8"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
